import { useMemo } from 'react';
import { SamplesLanguages } from 'types/enums';

export const useLocalePrefixes = () => {
    const prefixes = useMemo(
        () => [
            ...Object.values(SamplesLanguages).map((locale) =>
                locale === SamplesLanguages.EN ? '/' : `/${locale}/`,
            ),
        ],
        [],
    );

    return prefixes;
};
